import { render } from "./BulkAddUsers.vue?vue&type=template&id=8e3a76e6"
import script from "./BulkAddUsers.vue?vue&type=script&lang=js"
export * from "./BulkAddUsers.vue?vue&type=script&lang=js"

import "./BulkAddUsers.vue?vue&type=style&index=0&id=8e3a76e6&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__